<div
  id="application-sidebar"
  class="fixed bottom-0 start-0 z-[60] flex w-[300px] max-h-full transform flex-col border-e text-white transition-all duration-300 ease-in-out lg:translate-x-0"
  [style.top]="topOffset()"
  [style.background-color]="'var(--sidebar-bg)'"
  [style.border-color]="'var(--sidebar-border)'"
  [ngClass]="{
    'translate-x-0': isOpen(),
    '-translate-x-full': !isOpen(),
    'lg:w-16': !isOpen(),
  }"
  role="dialog"
  tabindex="-1"
  aria-label="Menu lateral"
  [attr.aria-hidden]="ariaHidden()"
>
  <div class="relative flex h-full max-h-full flex-col">
    <div
      class="flex h-[50px] shrink-0 items-center justify-between border-b px-4"
      [style.border-color]="'color-mix(in srgb, white 18%, transparent)'"
      [ngClass]="{ 'lg:justify-center lg:px-0': !isOpen() }"
    >
      <a
        routerLink="/"
        class="notranslate inline-block flex-none focus:outline-hidden focus:opacity-80"
        translate="no"
        aria-label="OneEduca"
      >
        @if (isOpen()) {
        <p class="text-lg font-bold leading-none tracking-tight text-white">
          One<span class="opacity-90">Educa</span>
        </p>
        <p
          class="mt-0.5 text-[0.5rem] font-medium uppercase leading-none tracking-[0.24em] text-white/70"
        >
          {{ brandLabel() }}
        </p>
        } @else {
        <p class="hidden text-lg font-bold leading-none text-white lg:block">
          OE
        </p>
        }
      </a>

      <button
        type="button"
        class="inline-flex size-5 items-center justify-center rounded border border-transparent text-white/80 hover:bg-white/15 focus:bg-white/15 focus:outline-hidden lg:hidden"
        (click)="closeSidebar.emit()"
        aria-label="Fechar sidebar"
      >
        <span class="sr-only">Fechar sidebar</span>
        <i class="bi bi-x-lg text-sm leading-none" aria-hidden="true"></i>
      </button>
    </div>

    <div
      class="min-h-0 flex-1 overflow-y-auto [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-white/30 [&::-webkit-scrollbar-track]:bg-transparent [&::-webkit-scrollbar]:w-2"
    >
      <nav
        class="flex w-full flex-col p-3"
        [ngClass]="{ 'lg:px-2': !isOpen() }"
      >
        <ul class="flex flex-col space-y-1.5">
          @for (item of navItems(); track item.label + item.route +
          (item.comingSoon ? '1' : '0')) {
          <li>
            @if (item.comingSoon) {
            <span
              [attr.title]="isOpen() ? 'Em breve' : item.label + ' (em breve)'"
              class="flex cursor-not-allowed items-center gap-x-3 rounded px-2.5 py-2 text-sm text-white/40"
              [ngClass]="{ 'lg:justify-center lg:gap-x-0 lg:px-0': !isOpen() }"
            >
              <i
                class="bi shrink-0 text-base leading-none"
                [ngClass]="'bi-' + item.iconClass"
                aria-hidden="true"
              ></i>
              <span class="line-clamp-1" [class.lg:hidden]="!isOpen()">
                {{ item.label }}
              </span>
            </span>
            } @else if (hasChildren(item) && !item.route) {
            <button
              type="button"
              class="flex w-full items-center gap-x-3 rounded px-2.5 py-2 text-sm font-normal text-white/90 transition-colors hover:bg-white/15 focus:bg-white/15"
              [ngClass]="{
                'bg-white/20': isDescendantActive(item),
                'lg:justify-center lg:gap-x-0 lg:px-0': !isOpen(),
              }"
              [attr.title]="!isOpen() ? item.label : null"
              [attr.aria-expanded]="isGroupExpanded(item.label)"
              (click)="toggleGroup(item)"
            >
              <i
                class="bi shrink-0 text-base leading-none"
                [ngClass]="'bi-' + item.iconClass"
                aria-hidden="true"
              ></i>
              <span
                class="min-w-0 flex-1 text-left line-clamp-1"
                [class.lg:hidden]="!isOpen()"
              >
                {{ item.label }}
              </span>
              <i
                class="bi bi-chevron-down shrink-0 text-[0.625rem] leading-none transition-transform"
                [class.lg:hidden]="!isOpen()"
                [class.rotate-180]="isGroupExpanded(item.label)"
                aria-hidden="true"
              ></i>
            </button>
            @if (isGroupExpanded(item.label) && isOpen()) {
            <ul class="mt-1 space-y-1 border-s border-white/15 ms-3 ps-2">
              @for (child of item.children; track child.label + child.route +
              (child.queryParams?.['role'] ?? '') + (child.queryParams?.['tab']
              ?? '')) {
              <li>
                <a
                  [routerLink]="child.route"
                  [queryParams]="child.queryParams ?? {}"
                  class="flex items-center gap-x-3 rounded px-2.5 py-1.5 text-sm font-normal text-white/90 transition-colors hover:bg-white/15 focus:bg-white/15"
                  [ngClass]="{
                    'bg-white/20': isItemActive(child),
                    'font-semibold': isItemActive(child),
                  }"
                  (click)="onNavClick()"
                >
                  <i
                    class="bi shrink-0 text-base leading-none"
                    [ngClass]="'bi-' + child.iconClass"
                    aria-hidden="true"
                  ></i>
                  <span class="line-clamp-1">{{ child.label }}</span>
                </a>
              </li>
              }
            </ul>
            } } @else {
            <a
              [routerLink]="item.route"
              [attr.title]="!isOpen() ? item.label : null"
              class="flex items-center gap-x-3 rounded px-2.5 py-2 text-sm font-normal text-white/90 transition-colors hover:bg-white/15 focus:bg-white/15"
              [ngClass]="{
                'bg-white/20': isItemActive(item),
                'font-semibold': isItemActive(item),
                'lg:justify-center lg:gap-x-0 lg:px-0': !isOpen(),
              }"
              (click)="onNavClick()"
            >
              <i
                class="bi shrink-0 text-base leading-none"
                [ngClass]="'bi-' + item.iconClass"
                aria-hidden="true"
              ></i>
              <span class="line-clamp-1" [class.lg:hidden]="!isOpen()"
                >{{ item.label }}</span
              >
            </a>
            }
          </li>
          }
        </ul>
      </nav>
    </div>

    <div
      class="shrink-0 border-t px-4 py-3"
      [style.border-color]="'color-mix(in srgb, white 18%, transparent)'"
      [class.lg:hidden]="!isOpen()"
    >
      <p
        class="notranslate text-[0.6875rem] leading-relaxed text-white/60"
        translate="no"
      >
        © 2026 OneEduca. Todos os direitos reservados.
      </p>
    </div>
  </div>
</div>
